import { Helper } from '../Helper';
export class GetCurrentModuleHelper extends Helper {
    emit(sb, node, options) {
        if (options.pushValue) {
            sb.scope.getGlobal(sb, node, options);
            sb.emitHelper(node, options, sb.helpers.getModule({ moduleIndex: sb.moduleIndex }));
        }
    }
}

//# sourceMappingURL=GetCurrentModuleHelper.js.map
